import _ from "lodash";
import React, { useEffect, useState } from "react";

import { useRootStore } from "store";
import OverlayLoader from "components/loader/OverlayLoader";
import InventoryCreator, {
  Option
} from "../components/inventoryCreator/InventoryCreator";
import InventoryTable from "../components/inventoryTable/InventoryTable";
import InventoryList from "../components/inventoryList/InventoryList";

export default function InventoryInternalUser() {
  const {
    global,
    user,
    inventory: inventoryState
  } = useRootStore((store) => store);

  const {
    articleRegister,
    fiscalYear,
    fiscalYearNotFound,
    inventories,
    inventory,
    isCreatingInventory,
    isCreatingInventoryPdf,
    isLoadingArticleRegister,
    isLoadingFiscalYear,
    isLoadingInventories,
    isLoadingInventory,
    isUpdatingInventoryState,
    clearInventory,
    createInventory,
    createInventoryPdf,
    getArticleRegister,
    getFiscalYear,
    getInventories,
    getInventory,
    updateInventoryState
  } = inventoryState;

  const { customerName } = useRootStore(
    (state) => state.customers.workingCustomer
  );

  const [selectedYear, setSelectedYear] = useState<string | null>(null);
  const [years, setYears] = useState<string[]>([]);

  useEffect(() => {
    const startYear = 2020;
    const currentYear = new Date().getFullYear();
    const possibleYears: string[] = [];

    for (let i = startYear; i <= currentYear + 1; i++) {
      possibleYears.push(i.toString());
    }

    const existingYears = inventories.map((i) => i.per_date.substring(0, 4));

    const filteredYears = possibleYears.filter(
      (y) => !existingYears.includes(y)
    );

    let newSelectedYear = selectedYear;
    if (filteredYears.length === 0) {
      newSelectedYear = null;
    } else if (selectedYear === null || !filteredYears.includes(selectedYear)) {
      newSelectedYear = filteredYears[0];
    }

    setSelectedYear(newSelectedYear);
    setYears(filteredYears);
  }, [inventories, selectedYear]);

  const username = `${user.userInfo?.givenName} ${user.userInfo?.surName}`;

  useEffect(() => {
    clearInventory();
    if (_.isEmpty(articleRegister)) {
      getArticleRegister();
    }
    getFiscalYear(global.workingCustomerId);
    getInventories(global.workingCustomerId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreate = () => {
    const perDate = `${selectedYear}-${fiscalYear.fiscalYearMonthEnd}-${fiscalYear.fiscalYearDayEnd}`;
    createInventory(global.workingCustomerId, perDate);
  };

  const handleGoBack = () => {
    clearInventory();
    getInventories(global.workingCustomerId);
  };

  const handleInventoryCreatePdf = (inventoryId: number) => {
    createInventoryPdf(
      global.workingCustomerId,
      inventoryId,
      customerName,
      username
    );
  };

  const handleInventoryOpen = (
    inventoryId: number,
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    getInventory(global.workingCustomerId, inventoryId);
  };

  const handleInventorySetOngoing = (inventoryId: number) => {
    updateInventoryState(global.workingCustomerId, inventoryId, "ongoing");
  };

  const handleYearChange = (option: Option) => {
    setSelectedYear(option.value);
  };

  const errorContent = (
    <p>Fel: Kunde inte hämta information om kundens räkenskapsår.</p>
  );
  const isInventoryEmpty = _.isEmpty(inventory);
  const isArticleRegisterEmpty = _.isEmpty(articleRegister);

  const mainContent = (
    <OverlayLoader
      isLoading={
        isCreatingInventory ||
        isCreatingInventoryPdf ||
        isLoadingArticleRegister ||
        isLoadingFiscalYear ||
        isLoadingInventories ||
        isLoadingInventory ||
        isUpdatingInventoryState
      }
    >
      <>
        {isInventoryEmpty && (
          <div>
            <InventoryList
              onInventoryOpen={handleInventoryOpen}
              onInventoryCreatePdf={handleInventoryCreatePdf}
              onInventorySetOngoing={handleInventorySetOngoing}
              isInternalUser
            />
            {selectedYear !== null && (
              <InventoryCreator
                onCreate={handleCreate}
                onYearChange={handleYearChange}
                isDisabled={years.length === 0}
                selectedYear={selectedYear}
                years={years}
              />
            )}
          </div>
        )}

        {!isInventoryEmpty && !isArticleRegisterEmpty && (
          <InventoryTable isInternalUser={true} onGoBack={handleGoBack} />
        )}

        {!isInventoryEmpty && isArticleRegisterEmpty && (
          <p>Inladdning av artiklar misslyckades. Pröva igen senare.</p>
        )}
      </>
    </OverlayLoader>
  );

  return <div>{fiscalYearNotFound ? errorContent : mainContent}</div>;
}
